namespace pixi_ui.component {
    interface IPadding {
        top: number;
        right: number;
        bottom: number;
        left: number;
    }

    export class VerticalGroup implements IComponent {
        public padding: IPadding;
        public spacing: number;

        constructor(padding: IPadding, spacing: number) {
            this.padding = padding;
            this.spacing = spacing;
        }

        public attach(element: Element): void {}

        public detach(element: Element): void {}

        public resize(element: Element): void {
            let py = -this.padding.top;
            element.children.forEach(child => {
                if (child instanceof Element) {
                    child.offsetTopLeft.y = py;
                    child.offsetBottomRight.y = py;
                    py -= child.contentHeight + this.spacing;
                }
            });
            element.contentHeight =
                Math.abs(py) - this.spacing + this.padding.bottom;
        }
    }
}
